import React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, Loading, SubmitButton } from 'components';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices';
import { useDeleteZoneCategoryMutation } from 'store/apis';

interface ZoneCategoryDeleteDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
  categoryId: number;
  setCategoryId: (categoryId?: number) => void;
}

export const ZoneCategoryDeleteDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Delete Zone Category',
  submitButtonLabel = 'Delete',
  categoryId: id,
  setCategoryId,
}: ZoneCategoryDeleteDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [deleteZoneCategory, { isLoading: loading_submit }] = useDeleteZoneCategoryMutation();
  const loading = false;

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onDelete = () => {
    if (orgSlug && id) {
      deleteZoneCategory({ orgSlug, id })
        .then(() => {
          setCategoryId();
          onClose(null, 'anyway');
        })
        .catch(() => {})
        .finally();
    }
  };

  return (
    <Dialog open={visible} onClose={onClose} fullScreen={false}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Loading text={'Loading Building...'} height={240} />
        ) : (
          <Box sx={{ paddingBottom: 2 }}>
            <Typography variant="body2" color="textSecondary">
              Do you really want to delete this zone category?
            </Typography>
            <Typography variant="body2" color="textSecondary">
              This process cannot be undone.
            </Typography>
          </Box>
        )}
      </DialogContent>

      {!loading && (
        <DialogActions>
          <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onDelete} />
        </DialogActions>
      )}

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
